import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import { CmsMaster } from '../../Values.js';
import {Link} from 'react-router-dom';


import { connect } from 'react-redux';

class SidebarUserBlock extends Component {

    state = {
        showUserBlock: false,
        aDatosUsuario: {
          sNombre: sessionStorage.getItem('sNombre'),
          sNombreCorto: sessionStorage.getItem('sNombreCorto'),
          sNombreContacto: sessionStorage.getItem('sNombreContacto'),
          sApellido_Paterno: sessionStorage.getItem('sApellido_Paterno'),
          sApellido_Materno: sessionStorage.getItem('sApellido_Materno'),
          iIDEmpresa: sessionStorage.getItem('iIDEmpresa'),
          iIDUsuario: sessionStorage.getItem('iIDUsuario'),
          sImagen: CmsMaster.sUrl + sessionStorage.getItem('sImagen'),
          sImagenContacto: CmsMaster.sUrl + (sessionStorage.getItem('sImagenContacto').trim() != "" ?  sessionStorage.getItem('sImagenContacto') : 'images/user-default.png' )
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.showUserBlock !== this.props.showUserBlock) {
            this.setState({ showUserBlock: newProps.showUserBlock })
        }
    }

    render() {
        return (
          <div>

            {/* Empresa logo */}
            <Collapse id="user-block" isOpen={ !this.state.showUserBlock }>
              <div className="item user-block text-center">
                {/* Empresa picture */}
                <div className="bg-center circle thumb48 p-2" style={{
                    //height:"40px",
                    //width:"auto",
                    backgroundImage: "url('"+this.state.aDatosUsuario.sImagen+"')",
                    //backgroundPosition: "center",
                    backgroundRepeat  : 'no-repeat'
                    //backgroundSize: "80px"
                  }}></div>
                  {/* Name and Job */}
                  <div className="user-block-info">
                    <span className="user-block-name">{this.state.aDatosUsuario.sNombreCorto}</span>
                  </div>
                </div>
            </Collapse>
            {/* Empresa logo end*/}

            {/* Usuario logo */}
            <Collapse id="user-block" isOpen={ this.state.showUserBlock }>
              <Link to={{
                  pathname: (this.state.aDatosUsuario.iIDUsuario != 0 ? '/cambiarcontrasena' : '/miempresa'),
                  state: (this.state.aDatosUsuario.iIDUsuario != 0 ? {iIdUsuario: this.state.aDatosUsuario.iIDUsuario} : {})
                }}>
                <div className="item user-block text-center">
                  <div className="bg-center circle thumb48 p-2" style={{
                      backgroundImage: "url('"+this.state.aDatosUsuario.sImagenContacto+"')",
                      backgroundRepeat  : 'no-repeat'
                    }}></div>
                    <div className="user-block-info">
                      <span className="user-block-name">{this.state.aDatosUsuario.sNombreContacto} {this.state.aDatosUsuario.sApellido_Paterno} {this.state.aDatosUsuario.sApellido_Materno}</span>
                    </div>
                  </div>
                </Link>
            </Collapse>
            {/* Empresa logo end*/}

            {/*<Collapse id="user-block" isOpen={ this.state.showUserBlock }>
              <Link to={{
                  pathname: (this.state.aDatosUsuario.iIDUsuario != 0 ? '/cambiarcontrasena' : '/miempresa'),
                  state: (this.state.aDatosUsuario.iIDUsuario != 0 ? {iIdUsuario: this.state.aDatosUsuario.iIDUsuario} : {})
                }}>
                <div className="item user-block">
                  <div className="user-block-picture">
                    <div className="user-block-status">
                      <img className="thumb48 circle" src={this.state.aDatosUsuario.sImagenContacto}/>
                      <div className="circle bg-success circle-lg"></div>
                    </div>
                  </div>
                  <div className="user-block-info">
                    <span className="user-block-name">{this.state.aDatosUsuario.sNombreContacto} {this.state.aDatosUsuario.sApellido_Paterno} {this.state.aDatosUsuario.sApellido_Materno}</span>
                  </div>
                </div>
              </Link>
            </Collapse>*/}

          </div>

        )
    }
}

SidebarUserBlock.propTypes = {
    showUserBlock: PropTypes.bool
};

const mapStateToProps = state => ({ showUserBlock: state.settings.showUserBlock })

export default connect(
    mapStateToProps
)(SidebarUserBlock);
